import { Box, Typography, IconButton, AddCircleIcon, SettingsIcon, UserFlag, Slide, ExpandCircleDownIcon,
    RetryImage
 } from 'src/components';
import { useState } from 'react';
import { TRANSPORT_MODE_MAPPINGS } from 'src/data';

import placeholderImage from 'src/assets/placeholders/white-140x140.png';

export default function StepCard({ isPublicPortal, step, handleViewChange, setSelectedStep, setDrawerState }) {
    const {
        name,
        description,
        startDate,
        imageUrls,
        transportMethod,
        point,
        countryIsoAlpha2,
    } = step;

    const [hover, setHover] = useState(false);

    const handleStepCardClicked = () => {
        setSelectedStep(step);
        setDrawerState("half");
    };
    
    return (
        <Box
        sx={{
            width: '100%', 
            position: 'relative'
        }}
        >

            <Box sx={{left: 33,  border: '1px solid #ccc', position: 'absolute', height: '100%', zIndex: 0}}></Box>

            {!isPublicPortal ? (
                <Box 
                    onClick={() => handleViewChange("AddStep")}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    sx={{
                        width: '40%', 
                        left: 23, 
                        position: 'absolute', 
                        display: 'flex',
                        alignItems: 'center',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        top: 9}}>

                    <AddCircleIcon fontSize="small" color="secondary" sx={{backgroundColor: 'white', borderRadius: '50%'}}/>

                    <Slide in={hover} direction="up" timeout={300}>
                        <Typography ml={1} variant="body3" fontWeight={600} color={"text.secondary"}>
                            Add a step
                        </Typography>
                    </Slide>

                </Box>
            ) : (
                <Box 
                    sx={{
                        width: '40%', 
                        left: 23, 
                        position: 'absolute', 
                        display: 'flex',
                        alignItems: 'center',
                        overflow: 'hidden',
                        top: 9}}>

                    <ExpandCircleDownIcon fontSize="small" color="secondary" sx={{backgroundColor: 'white', borderRadius: '50%'}}/>

                </Box>
            )}

            <Box
                sx={{
                    mt: 5,
                    display: 'flex',
                    flexDirection: 'row',
                    border: '1px solid #ccc',
                    borderRadius: 3,
                    backgroundColor: 'white',
                    overflow: 'hidden',
                    position: 'relative',
                    zIndex: 1,
                }}
                onClick={() => handleStepCardClicked()}
                >
                {/* Left Side Image (if exists) */}
                {imageUrls?.length > 0 && (
                    <RetryImage
                        mode="bg"
                        src={imageUrls[0]}
                        placeholder={placeholderImage}
                        placeholderDefault={true}
                        showLoader={true}
                        style={{ 
                            width: 120, 
                            borderRadius: 2,
                            borderTopRightRadius: 0, 
                            borderBottomRightRadius: 0
                        }}
                    />
                )}

                {/* Right Side Content */}
                <Box sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    
                    {/* Header Row */}
                    <Box display="flex" justifyContent="space-between" alignItems="center">

                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="h5" fontWeight={600}>
                                {name}
                            </Typography>
                            <Box>
                                {countryIsoAlpha2 && <UserFlag countryCode={countryIsoAlpha2} />}
                            </Box>
                        </Box>

                        {!isPublicPortal && (
                            <IconButton 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewChange("EditStep", null, step);
                                }} 
                                size="small">
                                <SettingsIcon fontSize="inherit" />
                            </IconButton>
                        )}
                    </Box>

                    {/* Description */}
                    {description && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        {description}
                    </Typography>
                    )}

                    {/* Footer Info */}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        mt={2}
                        sx={{ flexWrap: 'wrap', gap: 1 }}
                        >
                        <Typography variant="body2" color="text.secondary">
                            {new Date(startDate).toLocaleString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            })}
                        </Typography>

                    {/* Placeholder for Transport Method */}
                    {/* <Typography variant="body2">
                        {TRANSPORT_MODES.find(m => m.value === transportMethod)?.emoji || '❓'}
                    </Typography> */}
                    </Box>
                </Box>
            </Box>


        </Box>
    );
}
